module.exports = __webpack_public_path__ + "co.714d1724.svg";